export default __webpack_public_path__ + "static/media/test_cockails_zum_kinoprogramm_wien_im_autokino.1939ad0b.jpg";